import { Location } from 'vue-router'
import { FormsHandbook as Data } from '@/typings/api/FormsHandbook'

import { createEdit, DELETE } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { FORMS_HANDBOOK_ROUTES as ROUTES } from './utils'

const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Data>(getEditRoute),
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: true,
    width: 80,
  },
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: (data: Data): Location => ({
      name: ROUTES.VIEW,
      params: { id: data.id.toString() },
    }),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 140,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
])
